// extracted by mini-css-extract-plugin
export default {"spin-wrapper":"SessionInitializer__spin-wrapper___mWd16","spinWrapper":"SessionInitializer__spin-wrapper___mWd16"};